import {
  IndexTable,
  Card,
  useIndexResourceState,
  Text,
  Badge,
  Link,
  Avatar,
  InlineStack,
  BlockStack,
  Modal,
  Box,
  Button,
  InlineGrid,
  Tabs,
  Spinner,
  Pagination,
  Select,
  Icon,
  ResourceList,
  ResourceItem,
  Image,
  RadioButton
} from '@shopify/polaris';
import {
  CheckIcon,
  CheckCircleIcon,
  XIcon,
  ClockIcon,
  ImportIcon,
  ExternalIcon,
  PaymentIcon
} from '@shopify/polaris-icons';
import { useEffect, useState } from 'react';
import AppLayout from '../components/layout';
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';
import { getBestAvatar, getCreatorAffiliatePaymentSummary, getDealAffiliatePaymentSummary, getPaymentDueSummary, getRequiresAffiliatePayment, getRequiresPayment, numberToUSD } from '../utils';

export default function PaymentsTable({ valueForHomePage = false, onCreatorClick }) {
  const {
    leads, setToast, pastPayments, refetchPayments, store,
    allCodes, codesLoading, tremendousBalance } = usePartnerUp();

  const [invoiceLoading, setInvoiceLoading] = useState(null)
  const [confirmPayAllOpen, setConfirmPayAllOpen] = useState(false)
  const [payAllLoading, setPayAllLoading] = useState(false)

  const [creatorsPerPage, setCreatorsPerPage] = useState(10)
  const [page, setPage] = useState(0)

  const [paymentMethod, setPaymentMethod] = useState('PAYPAL')

  const resourceName = {
    singular: 'order',
    plural: 'orders',
  };

  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(pastPayments);

  async function getInvoice(paymentID) {
    try {
      setInvoiceLoading(paymentID)
      /*
      const res = await authFetch(`/api/invoice/${paymentID}`)
      const pdfString = await res.json()
*/
      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(pdfString) + "'></iframe>"
      )
    } catch (e) {
      console.error(e)
      setToast('There was an error getting the invoice', 'error')
    } finally {
      setInvoiceLoading(null)
    }
  }

  async function getBulkInvoice() {
    try {
      setInvoiceLoading('bulk')
      /*
      const res = await authFetch(`/api/invoice/bulk`, {
        method: 'POST',
        body: JSON.stringify({ paymentIDs: selectedResources }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const pdfString = await res.json()
*/
      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(pdfString) + "'></iframe>"
      )
    } catch (e) {
      console.error(e)
      setToast('There was an error getting the invoice', 'error')
    } finally {
      setInvoiceLoading(null)
    }
  }

  const unpaidCreators = {};
  const dueCreators = {}
  let totalCommissionPayment = 0;
  let totalCommissionPaymentDue = 0;

  if (allCodes?.length) {
    leads.forEach(lead => {
      const summary = getCreatorAffiliatePaymentSummary(lead.id, allCodes, true)
      if (summary.amountPending > 0) {
        console.log('pending', summary, lead)
        if (!unpaidCreators[lead.id]) {
          unpaidCreators[lead.id] = {
            creator: lead,
            orders: [],
            salesValue: 0,
            due: summary,
            unpaidCommission: summary.amountPending || 0
          }
        }
        unpaidCreators[lead.id].orders.push(...summary.pendingOrders)
        unpaidCreators[lead.id].salesValue += summary.salesValue
        if (summary?.amountDue) {
          totalCommissionPaymentDue += summary.amountPending
        }
      }
    })
  }
  console.log('dueCreators', dueCreators)
  console.log('unpaidCreators', unpaidCreators)


  const [activeTab, setActiveTab] = useState(0)

  function paypalEnabled(creator) {
    return (
      creator?.paypalMerchantID &&
      creator?.paypalEmailConfirmed &&
      creator?.paypalPaymentsReceivable
    )
  }

  const creatorsArray = Object.values(unpaidCreators || {}) //.concat(Object.values(creatorFixedPayments || {}))
  const dueCreatorsArray = Object.values(dueCreators || {}) //.concat(Object.values(creatorFixedPayments || {}))
  const payingCreators = dueCreatorsArray.filter(c => {
    if (paymentMethod === 'PAYPAL') {
      return paypalEnabled(c.creator)
    } else {
      return true
    }
  })

  const [checkedCreators, setCheckedCreators] = useState(payingCreators.map(c => String(creatorsArray.findIndex(cc => cc.creator.id === c.creator.id))))

  const totalPaying = checkedCreators.reduce((acc, c) => {
    return acc + (creatorsArray[c]?.unpaidCommission || creatorsArray[c]?.due?.amountDue)
  }, 0)

  useEffect(() => {
    if (paymentMethod === 'PAYPAL') {
      // uncheck creators that don't have paypal
      setCheckedCreators(checkedCreators.filter(c => {
        const creator = creatorsArray[c]?.creator || {}
        return creator?.paypalMerchantID && creator?.paypalEmailConfirmed && creator?.paypalPaymentsReceivable
      }))
    }
  }, [paymentMethod])

  console.log('orders', creatorsArray)
  async function payAll() {
    try {
      setPayAllLoading(true)
      /*
      const paypalRes = await authFetch(paymentMethod === 'PAYPAL' ? "/api/paypal/createOrder" : '/api/tremendous/pay', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          payingCreators: creatorsArray.filter((_, i) => checkedCreators.includes(String(i))).map(c => {
            let deal = null
            if (c.deal) {
              deal = {
                id: c.deal.id,
                campaignID: c.deal.campaignID,
                period: c.deal.period,
              }
            }
            return {
              creatorID: c.creator.id,
              creatorEmail: c.creator.email,
              creatorName: c.creator.name,
              paypalMerchantID: c.creator.paypalMerchantID,
              orders: c.orders,
              salesValue: c.salesValue,
              unpaidCommission: c.unpaidCommission,
              due: c.due,
              deal
            }
          })
        })
      })
      if (!paypalRes.ok) {
        if (paymentMethod === 'PAYPAL') {
          throw new Error('Error paying creators. Don\'t worry, no money was sent')
        } else {
          throw new Error('Error paying some creators. This is probably an issue with Tremendous')
        }
      } else {
        if (paymentMethod === 'PAYPAL') {
          const json = await paypalRes.json()
          const payerActionLink = json.links.find(l => l.rel === 'payer-action');
          window.top.location.href = payerActionLink.href
        } else {
          refetchPayments()
          setToast({
            content: 'Payments Sent!',
            error: false
          })
          setConfirmPayAllOpen(false)
        }
      }
*/
    } catch (e) {
      setPayAllLoading(false)
      refetchPayments()
      console.error('error paying', e)
      setToast({
        content: e?.message || 'Error paying creators',
        error: true
      })
    } finally {
    }
  }

  if (codesLoading) {
    return <Spinner />
  }

  if (!leads?.length) {
    return <Text>None Yet</Text>
  }

  if (valueForHomePage) { // too lazy to move all this state
    if ((totalCommissionPaymentDue)) { // + totalFixedPaymentsDue)) {
      return (
        <Text>
          You Have {numberToUSD(totalCommissionPaymentDue, store?.paymentSettings?.currencyCode)} for {dueCreators?.length} Creator(s) Currently Due
        </Text>
      )
    } else {
      return <Text>No Payments Due Right Now</Text>
    }
  }

  let rowMarkup
  let headings = []
  if (activeTab === 0) {
    headings = [
      { title: 'Creator' },
      // { title: 'Sales' },
      { title: 'Pending' },
      { title: 'Due' },
      { title: 'Type' },
      { title: 'PayPal' }
    ]
    rowMarkup = []
    creatorsArray.forEach(
      (creator, idx) => {
        const dueNow = dueCreators[creator.creator.id]
        rowMarkup.push(
          <IndexTable.Row
            id={idx}
            key={idx}
            // selected={selectedResources.includes(payment.id)}
            position={idx}
          >
            <IndexTable.Cell>
              <Link removeUnderline onClick={() => onCreatorClick(creator?.creator?.id)}>
                <InlineStack gap="2" blockAlign="center" align="start">
                  <Avatar size="small" shape="square" source={getBestAvatar(creator.creator)} initials={creator.creator?.name?.[0]} />
                  {creator?.creator?.name}
                </InlineStack>
              </Link>
            </IndexTable.Cell>
            {/*
            <IndexTable.Cell>{(creator.salesValue || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</IndexTable.Cell>
          */}
            <IndexTable.Cell>
              {
                creator?.unpaidCommission > 0 ? (
                  (creator.unpaidCommission || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                ) : (
                  (creator.due?.amountDue || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                )
              }
            </IndexTable.Cell>
            <IndexTable.Cell>
              {
                dueNow?.unpaidCommission > 0 ? (
                  (dueNow.unpaidCommission || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                ) : (
                  (creator.due?.amountDue || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                )
              }
            </IndexTable.Cell>
            <IndexTable.Cell>
              {
                creator?.unpaidCommission > 0 ? (
                  <Badge status="info">Affiliate</Badge>
                ) : (
                  <Badge>Fixed Payment</Badge>
                )
              }
            </IndexTable.Cell>
            <IndexTable.Cell>
              <InlineStack align="start">
                <InlineStack>
                  {
                    creator?.creator?.paypalMerchantID && creator?.creator?.paypalEmailConfirmed && creator?.creator?.paypalPaymentsReceivable ? (
                      <Icon source={CheckIcon} color="success" />
                    ) : (
                      <Icon source={XIcon} color="subdued" />
                    )
                  }
                </InlineStack>
              </InlineStack>
            </IndexTable.Cell>
          </IndexTable.Row>
        )
      }
    )
  } else {
    headings = [
      { title: 'Creator' },
      { title: 'Payment Value' },
      { title: 'Payment Method' },
      { title: 'Type' },
      { title: 'Payment Date' },
      { title: 'Invoice' }
    ]
    rowMarkup = []
    pastPayments
      ?.sort((a, b) => {
        return new Date(b?.createdAt || Date.now()) - new Date(a?.createdAt || Date.now())
      })
      ?.slice((page * creatorsPerPage), (page * creatorsPerPage) + creatorsPerPage).forEach(
        (payment, idx) => {
          const creator = leads.find(l => l.id === payment.creatorID)
          rowMarkup.push(
            <IndexTable.Row
              id={payment.id}
              key={idx}
              selected={selectedResources.includes(payment.id)}
              position={idx}
            >
              <IndexTable.Cell>
                <Link removeUnderline onClick={() => onCreatorClick(creator?.creator?.id)}>
                  <InlineStack gap="2" align="start" blockAlign="center">
                    <Avatar size="small" shape="square" source={getBestAvatar(creator)} initials={creator?.name?.[0]} />
                    {creator?.name}
                  </InlineStack>
                </Link>
              </IndexTable.Cell>
              <IndexTable.Cell>
                {numberToUSD(payment.value, store?.paymentSettings?.currencyCode)}
              </IndexTable.Cell>
              <IndexTable.Cell>
                {
                  payment?.paymentMethod === 'TREMENDOUS' ? <Badge status="info">Tremendous</Badge> : <Badge>PayPal</Badge>
                }
              </IndexTable.Cell>
              <IndexTable.Cell>
                {payment.paymentType === 'affiliate' ? <Badge status="success">Affiliate</Badge> : <Badge status="info">Fixed</Badge>}
              </IndexTable.Cell>
              <IndexTable.Cell>{payment.createdAt ? new Date(payment.createdAt)?.toLocaleDateString() : '-'}</IndexTable.Cell>
              <IndexTable.Cell>
                <Button loading={invoiceLoading === payment.id} onClick={() => getInvoice(payment.id)} icon={ImportIcon}></Button>
              </IndexTable.Cell>
            </IndexTable.Row>
          )
        }
      )
  }

  const promotedBulkActions = [
    {
      content: invoiceLoading === 'bulk' ? <Spinner size="small" /> : 'Generate Bulk Invoice',
      onAction: getBulkInvoice,
    },
  ];
  const bulkActions = [
  ];

  console.log('pmt method', paymentMethod)

  console.log('creatorsArray', creatorsArray)

  return (
    <AppLayout>
      <InlineStack align="center">
        <Box maxWidth="1500px" width="1500px">
          <BlockStack gap="300">
            <Modal
              open={confirmPayAllOpen}
              large
              onClose={() => setConfirmPayAllOpen(false)}
              title="Pay Creators"
              primaryAction={{
                content: `Pay ${numberToUSD(totalPaying, store?.paymentSettings?.currencyCode)} With ${paymentMethod === 'PAYPAL' ? 'PayPal' : 'Tremendous'}`,
                onAction: payAll,
                loading: payAllLoading,
                disabled: !checkedCreators.length || !store?.appSubscription || tremendousBalance < totalPaying
              }}
              secondaryActions={[
                {
                  content: 'Cancel',
                  onAction: () => setConfirmPayAllOpen(false)
                }
              ]}
            >
              <Box padding="2">
                <BlockStack gap="2">
                  <InlineGrid columns="3" gap="2">
                    {store?.tremendous?.campaign_id ? (
                      <Card padding="2" background={paymentMethod === 'TREMENDOUS' ? 'bg-info-subdued-hover' : ''}>
                        <BlockStack gap="100" align="center">
                          <Box onClick={() => !store?.tremendous?.campaign_id ? null : setPaymentMethod('TREMENDOUS')}>
                            <InlineStack gap="100" align="start" blockAlign="center">
                              <RadioButton checked={paymentMethod === 'TREMENDOUS'} disabled={!store?.tremendous?.campaign_id} onChange={() => setPaymentMethod('TREMENDOUS')} />
                              <Image source="https://assets.codepen.io/6060109/tremendous-logo-square.jpeg" width="10%" />
                              <InlineStack align="space-between">
                                <InlineStack gap="100" align="start">
                                  <Text variant="headingMd">Tremendous</Text>
                                </InlineStack>
                              </InlineStack>
                              <InlineStack align="start" gap="2">
                                <div style={{ width: '25px' }} />
                                <Text color="subdued">4% Fee</Text>
                                {
                                  !tremendousBalance ? <Link removeUnderline external url="https://tremendous.com">Add Funds</Link> : (
                                    <Link removeUnderline external url="https://tremendous.com">{tremendousBalance} Available</Link>
                                  )
                                }
                              </InlineStack>
                            </InlineStack>
                          </Box>
                        </BlockStack>
                      </Card>
                    ) : null}
                    < Card padding="2" background={paymentMethod === 'PAYPAL' ? 'bg-info-subdued-hover' : ''}>
                      <Box onClick={() => setPaymentMethod('PAYPAL')}>
                        <InlineStack gap="100" blockAlign="center">
                          <RadioButton checked={paymentMethod === 'PAYPAL'} onChange={() => setPaymentMethod('PAYPAL')} />
                          <Image source="https://assets.codepen.io/6060109/pp-logo.webp" width="40%" />
                          <InlineStack gap="100">
                            <div style={{ width: '25px' }} />
                            <InlineStack align="start" gap="2">
                              <Text color="subdued">3% Fee</Text>
                              <Text color="subdued">Pay up to 10 at a time</Text>
                            </InlineStack>
                          </InlineStack>
                        </InlineStack>
                      </Box>
                    </Card>
                  </InlineGrid>
                  <BlockStack>
                    <ResourceList
                      headerContent={
                        "Select Creators to Pay"
                      }
                      resourceName={{ singular: 'creator', plural: 'creators' }}
                      emptyState={
                        <BlockStack gap="2">
                          <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="4" paddingBlockEnd="2">
                            <InlineStack gap="2" align="start">
                              <Text variant="headingMd">No Payments</Text>
                            </InlineStack>
                          </Box>
                        </BlockStack>
                      }
                      selectable
                      items={creatorsArray || []}
                      selectedItems={checkedCreators}
                      onSelectionChange={(selected) => {
                        const creator = creatorsArray[selected[selected.length - 1]]?.creator || {}
                        if (paymentMethod === 'PAYPAL' && (!creator?.paypalMerchantID || !creator?.paypalEmailConfirmed || !creator?.paypalPaymentsReceivable)) {
                          setToast({
                            content: 'Creator has not connected their PayPal',
                            error: true
                          })
                        } else if (paymentMethod === 'PAYPAL' && checkedCreators.length >= 10) {
                          setToast({
                            content: 'You can only pay 10 creators at a time with PayPal',
                            error: true
                          })
                        } else {
                          setCheckedCreators(selected)
                        }
                      }}
                      renderItem={(c, i) => {
                        const paypalAdded = c.creator?.paypalMerchantID && c.creator?.paypalEmailConfirmed && c.creator?.paypalPaymentsReceivable
                        const handle = c.creator?.handle || c.creator?.profile?.profile?.handle || c.creator?.profile?.profile?.username
                        console.log('c', c)
                        return (
                          <ResourceItem
                            id={i}
                            url={null}
                            media={<Avatar size="large" shape="square" source={getBestAvatar(c.creator)} initials={c.creator?.name?.[0]} />}
                          >
                            <InlineGrid columns="1fr 2fr 1fr" alignItems="center" blockAlign="center">
                              <BlockStack align="center">
                                <Text variant="headingMd">{c.creator?.name}</Text>
                                <Text variant="subdued">{c?.creator?.email}</Text>
                              </BlockStack>
                              <BlockStack align="center">
                                <Text variant="headingMd">{numberToUSD(c.unpaidCommission || c?.due?.amountDue, store?.paymentSettings?.currencyCode)}</Text>
                                <Text variant="bodyMd">
                                  <Text>Commission for {c?.orders?.length} Order(s)</Text>
                                </Text>
                              </BlockStack>
                              {
                                paymentMethod === 'PAYPAL' ? (
                                  <InlineStack inlineAlign="end" align="center">
                                    <Text>PayPal</Text>
                                    <InlineStack align="center">
                                      {
                                        paypalAdded ? (
                                          <Icon source={CheckIcon} color="success" />
                                        ) : <Icon source={XIcon} color="critical" />
                                      }
                                    </InlineStack>
                                  </InlineStack>
                                ) : null
                              }
                            </InlineGrid>
                          </ResourceItem>
                        )
                      }} />
                  </BlockStack>
                </BlockStack>
              </Box>
            </Modal>
            <InlineStack blockAlign="center" align="space-between">
              <InlineStack blockAlign="center" gap="2" align="start">
                <InlineStack>
                  <Icon source={PaymentIcon} />
                </InlineStack>
                <Text variant="headingXl">Payments</Text>
              </InlineStack>
              <Button size="micro" plain icon={ExternalIcon} external url="https://partnerup.helpscoutdocs.com/article/18-paying-creators">How Payments Work</Button>
            </InlineStack>
            <InlineGrid columns="4fr 5fr" alignItems="center">
              <Tabs tabs={[
                {
                  content: 'Pending & Due',
                  id: 'pending',
                },
                {
                  content: 'Payment History',
                  id: 'paid',
                }
              ]} selected={activeTab} onSelect={setActiveTab} />
              <InlineStack gap="2" align="end">
                <Card padding="300" background="bg-subdued">
                  {
                    !totalCommissionPaymentDue ? (
                      <InlineStack gap="100">
                        <InlineStack>
                          <Icon source={CheckCircleIcon} color="subdued" />
                        </InlineStack>
                        <Text variant="headingMd">All Caught Up!</Text>
                      </InlineStack>
                    ) : (
                      <InlineStack gap="100">
                        <InlineStack>
                          <Icon source={PaymentIcon} color="subdued" />
                        </InlineStack>
                        <Text variant="headingMd">{numberToUSD(totalCommissionPaymentDue)} for {creatorsArray?.length} Creator(s) Due</Text>
                      </InlineStack>
                    )
                  }
                </Card>
                <Button disabled={!(totalCommissionPaymentDue)} primary onClick={() => setConfirmPayAllOpen(true)}>Pay</Button>
                <Box />
              </InlineStack>
            </InlineGrid>
            <Card>
              <IndexTable
                hasZebraStriping
                resourceName={resourceName}
                itemCount={activeTab === 0 ? creatorsArray?.length : pastPayments?.length}
                emptyState={<BlockStack gap="2" inlineAlign="center">
                  {
                    activeTab === 0 ? (
                      <>
                        <Text variant="heading3xl">
                          👍
                        </Text>
                        <Text variant="headingMd">
                          No Payments Due
                        </Text>
                      </>
                    ) : (
                      <>
                        <Icon source={ClockIcon} />
                        <Text variant="headingMd">
                          No Payments Yet
                        </Text>
                      </>
                    )
                  }
                </BlockStack>}
                selectable={activeTab === 1 ? true : false}
                selectedItemsCount={
                  allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                headings={headings}
                bulkActions={bulkActions}
                promotedBulkActions={promotedBulkActions}
              >
                {rowMarkup}
              </IndexTable>
              {
                activeTab === 1 ? (
                  <InlineStack align="end">
                    <Select
                      label="Rows per page"
                      labelHidden
                      options={['Show 10', 'Show 20', 'Show 50']}
                      value={'Show ' + creatorsPerPage}
                      onChange={v => {
                        setCreatorsPerPage(Number(v.split(' ')?.[1]))
                        setPage(0)
                      }}
                    />
                    <Pagination
                      hasPrevious={page > 0}
                      hasNext={page < Math.ceil(pastPayments?.length / creatorsPerPage) - 1}
                      onPrevious={() => setPage(page - 1)}
                      onNext={() => setPage(page + 1)}
                    />
                  </InlineStack>
                ) : null
              }
            </Card>
          </BlockStack>
        </Box>
      </InlineStack >
    </AppLayout>
  );
}

